import type { IconData } from '@stacksjs/iconify-core'

export const navigationArrowOff: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M16.2 12.143c7.842-3.1 17.18-5.982 24.505-6.913a1.837 1.837 0 0 1 2.064 2.065c-.928 7.307-3.799 16.619-6.89 24.448M11 14.328c-3.265 1.46-6.019 2.878-7.897 4.076c-1.119.713-.946 2.23.218 2.868l15.118 8.289l8.289 15.118c.638 1.164 2.154 1.337 2.868.217c1.198-1.878 2.616-4.631 4.076-7.896M42 6L26 22m-7 7l3.5-3.5M7 3l38 38\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default navigationArrowOff
